import _ from 'underscore'
import Vue from 'vue'
import {
  ADD_NOTIFICATION, REMOVE_NOTIFICATION,
  REMOVE_ALL_NOTIFICATIONS, REMOVE_NOTIFICATION_WITH_ITEM,
} from '../mutation-types'

const state = {}

const getters = {
  allNotifications(state) {
    return _.values(state);
  },
}

const actions = {
  
}

const mutations = {
  LOGOUT_SUCCESS() {
    for (let prop in state) Vue.delete(state, prop);
  },

  [ADD_NOTIFICATION](state, payload) {
    Vue.set(state, payload.notification.id, payload.notification);
  },

  [REMOVE_NOTIFICATION](state, payload) {
    Vue.delete(state, payload.notification.id);
  },

  [REMOVE_ALL_NOTIFICATIONS](state, payload) {
    for (let prop in state) Vue.delete(state, prop);
  },

  [REMOVE_NOTIFICATION_WITH_ITEM](state, payload) {
    var notification = _.where(_.values(state), payload);
    if (notification.length > 0) {
      Vue.delete(state, notification[0].id);
    }
  }
}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js